import { palette } from '@livable/saas-react-components';
import { alpha } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

// Headings an admin writes into a banner's text stay headings, at a size a strip can hold (LB-5968).
const bodyHeading = fontSize => ({
  fontFamily: palette.fontFamilies.poppins,
  fontSize,
  lineHeight: '20px',
  fontWeight: 600,
  margin: '0',
  color: palette.shades[800]
});

// One severity's colours: text and action in the dark shade (the main one is too light to read on the tint), the icon
// in the main shade, and a hairline border in its own hue (the light shade would not show against the page).
const severity = colors => ({
  borderColor: alpha(colors.main, 0.35),
  '& .MuiTypography-h4': {
    color: colors.dark
  },
  '& p, li, h1, h2, h3, h4, h5, h6': {
    color: colors.dark
  },
  '& .MuiAlert-icon': {
    color: colors.main
  },
  '& .MuiAlert-action path': {
    fill: palette.shades[700]
  },
  '& .MuiButton-text': {
    color: colors.dark
  }
});
const useStyles = makeStyles({
  content: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    columnGap: '16px',
    rowGap: '6px'
  },
  copy: {
    flex: '1 1 320px',
    minWidth: 0
  },
  title: {
    '&.MuiTypography-h4': {
      fontSize: '14px',
      lineHeight: '20px',
      fontWeight: 600
    }
  },
  // The theme's buttons never wrap, so a long action would run out of the strip. This one keeps its own width beside
  // the text and drops below it when there is no room; only one wider than the strip wraps its words.
  action: {
    '&.MuiButton-root': {
      flexShrink: 0,
      maxWidth: '100%',
      height: 'auto',
      minHeight: '32px',
      textAlign: 'left',
      whiteSpace: 'normal'
    }
  },
  bannerContent: {
    '& p': {
      fontSize: '13px',
      lineHeight: '18px',
      fontWeight: '400',
      color: palette.shades[800],
      margin: '0'
    },
    '& h1': bodyHeading('15px'),
    '& h2': bodyHeading('15px'),
    '& h3': bodyHeading('14px'),
    '& h4': bodyHeading('14px'),
    '& h5': bodyHeading('13px'),
    '& h6': bodyHeading('13px'),
    // The admin editor writes lists too; without this they keep the browser's margins and a card's height.
    '& ul, & ol': {
      margin: '2px 0 0',
      paddingLeft: '18px'
    },
    '& li': {
      fontSize: '13px',
      lineHeight: '18px',
      color: palette.shades[800]
    }
  },
  alertWrapper: {
    marginBottom: '8px',
    '& .MuiAlert-root': {
      alignItems: 'center',
      padding: '6px 8px 6px 14px',
      borderRadius: '8px',
      border: '1px solid transparent'
    },
    '& .MuiAlert-icon': {
      alignSelf: 'center',
      padding: 0,
      marginRight: '12px',
      fontSize: '20px'
    },
    '& .MuiAlert-message': {
      flex: 1,
      minWidth: 0,
      padding: '4px 0'
    },
    '& .MuiAlert-action': {
      alignSelf: 'center',
      padding: '0 0 0 8px',
      marginRight: 0
    },
    // The theme's close is sized for a card; at its 32px it would set the strip's height.
    '& .MuiAlert-action .MuiSvgIcon-root': {
      fontSize: '20px'
    },
    '& .MuiAlert-standardInfo': severity(palette.info),
    '& .MuiAlert-standardSuccess': severity(palette.success),
    '& .MuiAlert-standardWarning': severity(palette.warning),
    '& .MuiAlert-standardError': severity(palette.error)
  }
});
export default useStyles;